(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const productGallery = document.querySelector('.product-gallery__main_pdp');
    const thumbnailGallery = document.querySelector('.product-gallery__thumbnails_pdp');

    function loadSlider() {
      if(!productGallery) return;
      // Check if we're using Flickity (especially important for mobile)
      const isUsingFlickity = productGallery.classList.contains('flickity-enabled');
        
        // Store Flickity options before destroying
        let productFlickityOptions = {
          wrapAround: true,
          adaptiveHeight: true,
          dragThreshold: 10,
          imagesLoaded: true,
          pageDots: true,
          prevNextButtons: true,
          autoPlay: false,
          fade: false,
          arrowShape: window.arrowShape || {'x0': 10, 'x1': 60, 'y1': 50, 'x2': 65, 'y2': 45, 'x3': 20},
          cellSelector: '.product-gallery__image:not(.is-hidden)',
          rightToLeft: window.Shopify.locale === 'ar' && true,
        };
        
        let thumbnailFlickityOptions = {
          asNavFor: '.product-gallery__main_pdp',
          contain: true,
          pageDots: false,
          prevNextButtons: true,
          cellAlign: 'left',
          groupCells: true,
          dragThreshold: 10,
          imagesLoaded: true
        };
        
        // Store references to hidden elements that will be temporarily removed
        const hiddenSlides = [];
        const hiddenThumbnails = [];
        
        
        if (isUsingFlickity) {
          try {
            // Get Flickity instances

            const productFlickityInstance = window.Flickity.data(productGallery);
            const thumbnailFlickityInstance = thumbnailGallery ? window.Flickity.data(thumbnailGallery) : null;
            
            // Store options before destroying
            if (productFlickityInstance) {
              // Preserve existing options
              if (productFlickityInstance.options.wrapAround !== undefined) 
                productFlickityOptions.wrapAround = productFlickityInstance.options.wrapAround;
              if (productFlickityInstance.options.adaptiveHeight !== undefined) 
                productFlickityOptions.adaptiveHeight = productFlickityInstance.options.adaptiveHeight;
              if (productFlickityInstance.options.pageDots !== undefined) 
                productFlickityOptions.pageDots = productFlickityInstance.options.pageDots;
              if (productFlickityInstance.options.prevNextButtons !== undefined) 
                productFlickityOptions.prevNextButtons = productFlickityInstance.options.prevNextButtons;
              if (productFlickityInstance.options.autoPlay !== undefined) 
                productFlickityOptions.autoPlay = productFlickityInstance.options.autoPlay;
              if (productFlickityInstance.options.fade !== undefined) 
                productFlickityOptions.fade = productFlickityInstance.options.fade;
              if (productFlickityInstance.options.watchCSS !== undefined) 
                productFlickityOptions.watchCSS = productFlickityInstance.options.watchCSS;
              if (productFlickityInstance.options.arrowShape !== undefined) 
                productFlickityOptions.arrowShape = productFlickityInstance.options.arrowShape;
              
              // Destroy Flickity instance
              productFlickityInstance.destroy();
            }
            
            // Handle thumbnail gallery if it exists
            if (thumbnailGallery && thumbnailFlickityInstance) {
              // Preserve existing options
              if (thumbnailFlickityInstance.options.contain !== undefined) 
                thumbnailFlickityOptions.contain = thumbnailFlickityInstance.options.contain;
              if (thumbnailFlickityInstance.options.pageDots !== undefined) 
                thumbnailFlickityOptions.pageDots = thumbnailFlickityInstance.options.pageDots;
              if (thumbnailFlickityInstance.options.prevNextButtons !== undefined) 
                thumbnailFlickityOptions.prevNextButtons = thumbnailFlickityInstance.options.prevNextButtons;
              if (thumbnailFlickityInstance.options.cellAlign !== undefined) 
                thumbnailFlickityOptions.cellAlign = thumbnailFlickityInstance.options.cellAlign;
              if (thumbnailFlickityInstance.options.groupCells !== undefined) 
                thumbnailFlickityOptions.groupCells = thumbnailFlickityInstance.options.groupCells;
              if (thumbnailFlickityInstance.options.arrowShape !== undefined) 
                thumbnailFlickityOptions.arrowShape = thumbnailFlickityInstance.options.arrowShape;
              
              // Destroy thumbnail Flickity instance
              thumbnailFlickityInstance.destroy();
            }
          } catch (error) {
            console.error('Error destroying Flickity instances:', error);
          }
        }



        
        // Restore opacity for smooth transition
        if (thumbnailGallery) thumbnailGallery.style.opacity = '1';
        
        // Reinitialize Flickity after a short delay to ensure DOM updates are complete
        setTimeout(() => {
          if (isUsingFlickity || window.innerWidth < 798) { // Always initialize on mobile
            try {
              const galleryImagesNotHidden = productGallery.querySelectorAll('.product-gallery__image:not(.is-hidden)');

              galleryImagesNotHidden.forEach(image => {
                image.classList.remove('mobile-hide');
              });


              // Initialize main gallery Flickity
              new window.Flickity(productGallery, productFlickityOptions);
              
              // Initialize thumbnail gallery Flickity if it exists
              if (thumbnailGallery) {
                new window.Flickity(thumbnailGallery, thumbnailFlickityOptions);
              }
              
              // Add event listeners for video handling if needed
              const newProductFlickityInstance = window.Flickity.data(productGallery);
              if (newProductFlickityInstance) {
                newProductFlickityInstance.on('change', () => {
                  // Handle video pausing/playing logic if needed
                  const selectedSlide = productGallery.querySelector('.is-selected');
                  if (selectedSlide) {
                    const mediaType = selectedSlide.getAttribute('data-media-type');
                    if (mediaType === 'video' || mediaType === 'external_video') {
                      const video = selectedSlide.querySelector('video');
                      if (video) {
                        video.play();
                      }
                    }
                    else {
                      galleryImagesNotHidden.forEach(image => {
                        const video = image.querySelector('video');
                        if (video) {
                          video.pause();
                        }
                      });
                    }
                  }
                });
              }
              
              // Restore hidden slides to DOM (but keep them hidden with CSS)
              // This ensures they're still in the DOM for future color changes
              setTimeout(() => {
                hiddenSlides.forEach(item => {
                  item.parent.appendChild(item.element);
                  item.element.style.display = 'none'; // Ensure it stays hidden
                });
                
                hiddenThumbnails.forEach(item => {
                  item.parent.appendChild(item.element);
                  item.element.style.display = 'none'; // Ensure it stays hidden
                });
              }, 100);
            } catch (error) {
              console.error('Error initializing Flickity:', error);
            }
          }
        }, 300);

    }


    function updateProductImages(selectedColor) {
      if (!productGallery) return;
      
      const galleryImages = productGallery.querySelectorAll('.product-gallery__image');
      const thumbnails = thumbnailGallery ? thumbnailGallery.querySelectorAll('.product-gallery__thumbnail') : [];
      
      // Preserve height to prevent layout shift (mobile only)
      const isMobile = window.innerWidth <= 798;
      if (isMobile) {
        const currentHeight = productGallery.offsetHeight;
        if (currentHeight > 0) {
          productGallery.style.minHeight = currentHeight + 'px';
        }
      }
      
      // Add transition for smooth effect
      productGallery.style.transition = 'opacity 0.3s ease';
      if (thumbnailGallery) thumbnailGallery.style.transition = 'opacity 0.3s ease';
      
      productGallery.style.opacity = '0.5';
      if (thumbnailGallery) thumbnailGallery.style.opacity = '0.5';

      galleryImages.forEach((image, index) => {
          // Used for images staying in one position
          if (!image.closest('.is-selected') && !image.querySelector('.main-pdp-image')) {
             image.classList.add('mobile-hide');
          }
      });
      
      // Process after a short delay to allow opacity transition
      setTimeout(() => {
        let hasVisibleImages = false;
        
        // Process main gallery images
        galleryImages.forEach((image, index) => {
          // Used for images staying in one position
          const img = image.querySelector('img');
          if (img) {
            const altText = img.getAttribute('alt') || '';
            const isMatchingColor = altText.toLowerCase().includes(`- ${selectedColor.toLowerCase()}`);
            
            // Show/hide based on color match
            if (isMatchingColor) {
              image.classList.remove('is-hidden');
              hasVisibleImages = true;
              if(window.screen.width > 799){
                image.querySelector('video')?.play();
              }
            } else {
              image.classList.add('is-hidden');
              if(window.screen.width > 799){
                image.querySelector('video')?.pause();
              }
            }
          }
        });
        
        // Process thumbnails if they exist
        thumbnails.forEach((thumbnail) => {
          const img = thumbnail.querySelector('img');
          if (img) {
            const altText = img.getAttribute('alt') || '';
            const isMatchingColor = altText.toLowerCase().includes(`- ${selectedColor.toLowerCase()}`);
            
            // Show/hide based on color match
            if (isMatchingColor) {
              thumbnail.classList.remove('is-hidden');
            } else {
              thumbnail.classList.add('is-hidden');
            }
          }
        });
        
        // If no images match the color, show all images as fallback
        if (!hasVisibleImages) {
          galleryImages.forEach(image => {
            image.classList.remove('is-hidden');
          });
          
          thumbnails.forEach(thumbnail => {
            thumbnail.classList.remove('is-hidden');
          });
        }

        loadSlider()
        productGallery.style.opacity = '1';
        
        // Reset min-height after slider loads (mobile only)
        if (isMobile) {
          setTimeout(() => {
            productGallery.style.minHeight = '';
          }, 500);
        }
        
      }, 300);
    }

    let currentColor = document.querySelector('.swatch__options[data-variant-option-index="1"] .swatch__option input:checked').value;

    updateProductImages(currentColor.toLowerCase()); 

    let isMobile = false;
    window.addEventListener('resize', () => {
      currentColor = document.querySelector('.swatch__options[data-variant-option-index="1"] .swatch__option input:checked').value;

      if (window.innerWidth < 799 && !isMobile) {
        updateProductImages(currentColor.toLowerCase());
        isMobile = true;
      } else if (window.innerWidth >= 799 && isMobile) {
        const isUsingFlickity = productGallery.classList.contains('flickity-enabled');
        if (isUsingFlickity) {
          try {
            const productFlickityInstance = window.Flickity.data(productGallery);
            productFlickityInstance.destroy();
            updateProductImages(currentColor.toLowerCase());
          } catch (error) {
            console.error('Error destroying Flickity instances:', error);
          }
        }
        isMobile = false;
      }
    });

  const colorOptions = document.querySelectorAll('.swatch__options[data-variant-option-index="1"] .swatch__option input');
  colorOptions.forEach((option) => {
    option.addEventListener('change', (event) => {
      updateProductImages(event.target.value);
    });
  })

  // Update URL when variant changes (for product-newlayout section only)
  const variantSelection = document.querySelector('[data-variant-selection]');
  if (variantSelection) {
    // Update URL on variant change
    variantSelection.addEventListener('variant-change', (event) => {
      const { variant, state } = event.detail;
      
      // Only update URL if a variant is actually selected
      if (variant && state === 'selected') {
        // Use Shopify's built-in URL update function
        if (window.Shopify && window.Shopify.setParam) {
          window.Shopify.setParam('variant', variant.id);
        } else {
          // Fallback: manual URL update
          const url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }
    });
    
    // Trigger initial URL update on page load if first available variant is selected
    const initialVariant = variantSelection.getAttribute('variant');
    if (initialVariant && initialVariant !== 'not-selected' && initialVariant !== 'unavailable') {
      // Check if URL already has variant parameter
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('variant')) {
        if (window.Shopify && window.Shopify.setParam) {
          window.Shopify.setParam('variant', initialVariant);
        } else {
          const url = new URL(window.location);
          url.searchParams.set('variant', initialVariant);
          window.history.replaceState({}, '', url);
        }
      }
    }
  }

  }); 
})()
